export const GET_ALLOCATORS = "DASHBOARD@GET_ALLOCATORS";
export const GET_ALLOCATORS_INIT = "DASHBOARD@GET_ALLOCATORS_INIT";
export const GET_ALLOCATORS_SUCCESS = "DASHBOARD@GET_ALLOCATORS_SUCCESS";
export const GET_ALLOCATORS_FAILED = "DASHBOARD@GET_ALLOCATORS_FAILED";

export const GET_MY_FUND = "DASHBOARD@GET_MY_FUND";
export const GET_MY_FUND_INIT = "DASHBOARD@GET_MY_FUND_INIT";
export const GET_MY_FUND_SUCCESS = "DASHBOARD@GET_MY_FUND_SUCCESS";
export const GET_MY_FUND_FAILED = "DASHBOARD@GET_MY_FUND_FAILED";

export const GET_MEETINGS = "DASHBOARD@GET_MEETINGS";
export const GET_MEETINGS_INIT = "DASHBOARD@GET_MEETINGS_INIT";
export const GET_MEETINGS_SUCCESS = "DASHBOARD@GET_MEETINGS_SUCCESS";
export const GET_MEETINGS_FAILED = "DASHBOARD@GET_MEETINGS_FAILED";

export const GET_RECENT_CHAT = "DASHBOARD@GET_RECENT_CHAT";
export const GET_RECENT_CHAT_INIT = "DASHBOARD@GET_RECENT_CHAT_INIT";
export const GET_RECENT_CHAT_SUCCESS = "DASHBOARD@GET_RECENT_CHAT_SUCCESS";
export const GET_RECENT_CHAT_FAILED = "DASHBOARD@GET_RECENT_CHAT_FAILED";

export const GET_RECENT_POST = "DASHBOARD@GET_RECENT_POST";
export const GET_RECENT_POST_INIT = "DASHBOARD@GET_RECENT_POST_INIT";
export const GET_RECENT_POST_SUCCESS = "DASHBOARD@GET_RECENT_POST_SUCCESS";
export const GET_RECENT_POST_FAILED = "DASHBOARD@GET_RECENT_POST_FAILED";

export const GET_DASHBOARD_CONFIG = "DASHBOARD@GET_DASHBOARD_CONFIG";
export const GET_DASHBOARD_CONFIG_INIT = "DASHBOARD@GET_DASHBOARD_CONFIG_INIT";
export const GET_DASHBOARD_CONFIG_SUCCESS =
  "DASHBOARD@GET_DASHBOARD_CONFIG_SUCCESS";
export const GET_DASHBOARD_CONFIG_FAILED =
  "DASHBOARD@GET_DASHBOARD_CONFIG_FAILED";

export const UPDATE_DASHBOARD_CONFIG = "DASHBOARD@UPDATE_DASHBOARD_CONFIG";
export const UPDATE_DASHBOARD_CONFIG_INIT =
  "DASHBOARD@UPDATE_DASHBOARD_CONFIG_INIT";
export const UPDATE_DASHBOARD_CONFIG_SUCCESS =
  "DASHBOARD@UPDATE_DASHBOARD_CONFIG_SUCCESS";
export const UPDATE_DASHBOARD_CONFIG_FAILED =
  "DASHBOARD@UPDATE_DASHBOARD_CONFIG_FAILED";

export const GET_STAGE_ALLOCATION = "DASHBOARD@GET_STAGE_ALLOCATION";
export const GET_STAGE_ALLOCATION_INIT = "DASHBOARD@GET_STAGE_ALLOCATION_INIT";
export const GET_STAGE_ALLOCATION_SUCCESS = "DASHBOARD@GET_STAGE_ALLOCATION_SUCCESS";
export const GET_STAGE_ALLOCATION_FAILED = "DASHBOARD@GET_STAGE_ALLOCATION_FAILED";
